import { Box, Typography, Button } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Link from "next/link";

import { pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";

export default function Getintouch() {
  const { classes } = styles();
  return (
    <Box className={classes.container}>
      <Box className={classes.sub} borderRadius={2}>
        {/* <AvatarGroup>
          <Avatar alt="Remy Sharp" src="/images/home/Avatar.svg" />
          <Avatar alt="Cindy Baker" src="/images/home/Avatar-2.svg" />
          <Avatar alt="Travis Howard" src="/images/home/Avatar-1.svg" />
        </AvatarGroup> */}

        <Typography className={classes.name}>Still have questions?</Typography>
        <Button className={classes.btn}>
          <Link href="/contact">Contact Us</Link>
        </Button>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    minHeight: pxToRem(150),
    width: "100%",
    display: "flex",
    flexDirection: "row",
    backgroundColor: AppColors.neutral["90"],
  },
  sub: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    alignItems: "center",
    padding: theme.spacing(3),
    justifyContent: "space-evenly",
  },
  btn: {
    height: pxToRem(46),
    width: pxToRem(172),
    color: theme.colors.white,
    backgroundColor: AppColors.primary["300"],
    borderRadius: pxToRem(8),
  },
  name: {
    fontWeight: 500,
    fontSize: pxToRem(20),
  },
  det: {
    fontWeight: 400,
    fontSize: pxToRem(16),
  },
}));
